import { render, staticRenderFns } from "./career-teaching-detail.vue?vue&type=template&id=1b139e28&scoped=true&"
import script from "./career-teaching-detail.vue?vue&type=script&lang=js&"
export * from "./career-teaching-detail.vue?vue&type=script&lang=js&"
import style0 from "./career-teaching-detail.vue?vue&type=style&index=0&id=1b139e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b139e28",
  null
  
)

export default component.exports